document.addEventListener('DOMContentLoaded', function () {
	const cardStackedBlocks = document.querySelectorAll('.block-card-stacked');

	cardStackedBlocks.forEach((block) => {
		const container = block.querySelector('.block-card-stacked__container');
		const cards = block.querySelectorAll('.block-card');
		const initialShow = parseInt(block.dataset.initialShow, 10) || 6;
		const loadMoreCount = parseInt(block.dataset.loadMore, 10) || 3;

		if (!container || cards.length <= initialShow) {
			return;
		}

		cards.forEach((card, index) => {
			if (index >= initialShow) {
				card.classList.add('block-card--hidden');
			}
		});

		const loadMoreWrapper = document.createElement('div');
		loadMoreWrapper.className =
			'wp-block-button is-style-secondary wp-block-button--icon-right block-card-stacked__load-more';
		loadMoreWrapper.style.cssText = '--buttonIcon: var(--icon-maximize);';

		const loadMoreButton = document.createElement('button');
		loadMoreButton.type = 'button';
		loadMoreButton.className = 'wp-block-button__link';
		loadMoreButton.textContent = 'Load More';

		loadMoreWrapper.appendChild(loadMoreButton);
		container.appendChild(loadMoreWrapper);

		loadMoreButton.addEventListener('click', function () {
			const hiddenCards = block.querySelectorAll(
				'.block-card.block-card--hidden'
			);
			const cardsToShow = Array.from(hiddenCards).slice(0, loadMoreCount);

			cardsToShow.forEach((card) => {
				card.classList.remove('block-card--hidden');
			});

			const remainingHidden = block.querySelectorAll(
				'.block-card.block-card--hidden'
			);

			if (remainingHidden.length === 0) {
				loadMoreWrapper.remove();
			}
		});
	});
});
